export const EMPTY_ORDER_TEMPLATE = {
	points: [],
	distance: 0,
	route: [],
};

export const ORDERS_TYPES = {
	PRELIMINARY: "preliminary",
	EXECUTABLE: "executable",
	ALL: "all",
	CLOSED: "closed",
	LIVE: "live",
} as const;

export type OrderType = (typeof ORDERS_TYPES)[keyof typeof ORDERS_TYPES];

export const VISIBLE_ORDERS_COUNT = 60;
export const ORDERS_TABLE_PAGE_SIZE = 25;

export interface ModalInterface {
	label: string;
	type: string;
	position: string;
	groupId: string;
	visible: boolean;
	columnStart: number;
	rowStart: number;
	columnEnd: number;
	rowEnd: number;
}
